import React, { useState, useEffect } from 'react';
import '../../css/LeaveQuota.css';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import DateInput from '../common/DateInput';

registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
const loadingGif = process.env.REACT_APP_PUBLIC_URL + '/loading1.gif';

const ReturnFromLeave = ({ data, language, onSendMessage, isDisabled }) => {
    const { t } = useTranslation();

    function convertToCookieString(jsonObject) {
        const cookieArray = [];
        for (const [key, value] of Object.entries(jsonObject)) {
            cookieArray.push(`${key}=${value}`);
        }
        return cookieArray.join('; ');
    }

    const [selectedLeave, setSelectedLeave] = useState(null);
    const [returnDate, setReturnDate] = useState('');
    const [note, setNote] = useState('');
    const [workSchedules, setWorkSchedules] = useState([]);
    const [selectedWorkSchedule, setSelectedWorkSchedule] = useState('');
    const [isWorkScheduleRequired, setIsWorkScheduleRequired] = useState(false);
    const [csrfToken, setCSRFToken] = useState(data?.csrfToken)
    const [cookies, setCookies] = useState(data.cookies ? convertToCookieString(data?.cookies) : "")
    const [validationMessage, setValidationMessage] = useState('');
    const [isErrorMessage, setIsErrorMessage] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [isFormDisabled, setIsFormDisabled] = useState(isDisabled);
    const [isLoading, setIsLoading] = useState(false)
    const [attahcments, setAttachments] = useState([])
    const [validFiles, setValidFiles] = useState(true);
    const [attachmentFilesTypes, setAttachmentFilesTypes] = useState([
        "application/pdf",
        "image/jpeg",
        "image/tiff",
        "image/gif",
        "image/jpeg",
        "image/tiff"
    ]);

    useEffect(() => {
        setIsErrorMessage(false);
        setResponseMessage("")
    }, [])

    function formatDate(dateString) {
        const timestamp = dateString.match(/\d+/)[0];
        const date = new Date(parseInt(timestamp, 10));
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    }

    const validateForm = () => {
        if (!returnDate) {
            setValidationMessage(t('Return date is required.'));
            return false;
        }

        // const returnDateObj = new Date(returnDate);
        // const expectedReturnDateObj = new Date(parseInt(selectedLeave.Expdt.match(/\d+/)[0]));

        // if (returnDateObj <= expectedReturnDateObj) {
        //     setValidationMessage(t('Return date must be after the expected return date.'));
        //     return false;
        // }

        // Check if work schedule is required but not selected
        if (isWorkScheduleRequired && !selectedWorkSchedule) {
            setValidationMessage(t('Work schedule is required.'));
            return false;
        }
        if (!validFiles) {
            setValidationMessage(t("Invalid file type. Please upload PDF, JPEG, TIFF, or GIF files."));
            return false;
        }
        setValidationMessage(''); // Clear any previous messages if validation passes
        return true;
    };

    function formatDateForRequest(dateString) {
        // Create a new Date object using the provided date string
        const date = new Date(dateString);

        // Format the date as YYYY-MM-DDTHH:MM:SS
        const formattedDate = date.toISOString().split('.')[0];

        return formattedDate;
    }

    function addYearsToDate(dateString, yearsToAdd) {
        const timestamp = parseInt(dateString.replace(/\/Date\((\d+)\)\//, '$1')); // Extract timestamp from /Date(...)/ format
        const date = new Date(timestamp); // Convert to Date object
        date.setFullYear(date.getFullYear() + yearsToAdd); // Add the years
        return `/Date(${date.getTime()})/`; // Convert back to /Date(...)/ format
    }

    const handleSave = async () => {
        setIsFormDisabled(true)
        setIsLoading(true)
        setResponseMessage("")
        // Perform validation
        if (!validateForm()) {
            setIsFormDisabled(false)
            setIsLoading(false)
            return; // Exit if validation fails
        }
        // setValidationMessage("")
        // setIsErrorMessage(false)
        // setResponseMessage("")
        // Prepare the request body
        const requestBody = {
            Begda9201: selectedLeave.Begda9201,
            Endda9201: selectedLeave.Endda9201,
            Qid: selectedLeave.Qid,
            WorkitemId: selectedLeave.WorkitemId,
            Mailid: selectedLeave.Mailid,
            Mobile: selectedLeave.Mobile ? selectedLeave.Mobile : "",
            Pernr: selectedLeave.Pernr,
            Ename: selectedLeave.Ename,
            Ltyp: selectedLeave.Ltyp,
            Ltxt: selectedLeave.Ltxt,
            Rtyp: selectedLeave.Rtyp,
            Rtxt: selectedLeave.Rtxt,
            Expdt: selectedLeave.Expdt,
            Retdt: formatDateForRequest(returnDate), // User-provided return date
            Note: note ? note : "", // User-provided note
            Msg: "", // Add any message if needed
            Retcode: "", // Add return code if applicable
            Startdate: selectedLeave.Begda9201, // Assuming it's the same as Begda9201
            Enddate: addYearsToDate(selectedLeave.Begda9201, 2), // Assuming it's the same as Endda9201
            Schkz: selectedWorkSchedule, // Selected work schedule
            Ismat: selectedLeave.Ismat,
            Retext: "", // Add return text if needed
            sessionID: sessionStorage.getItem('sessionID'), // Get session ID from local storage
            xcsrfToken: csrfToken, // CSRF token stored in state
            cookies: cookies, // Cookies stored in state
            assertion: localStorage.getItem('id_token'), // SSO token
            language: localStorage.getItem('language'),
            frontendLog: JSON.stringify({
                sessionID: sessionStorage.getItem('sessionID'),
                EmployeeID: localStorage.getItem('EmployeeID'),
                channel: isMobile ? "Mobile" : "Portal",
                language: localStorage.getItem('language')
            })
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/createReturnFromLeave?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-csrf-token': csrfToken
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                if (response.status === 400) {
                    setIsFormDisabled(false)
                    setIsLoading(false)
                    return response.json().then(errorData => {
                        setIsErrorMessage(true);
                        setIsFormDisabled(false);
                        setResponseMessage(errorData.errorData[0]);
                    });
                } else {
                    setIsErrorMessage(true);
                    setIsFormDisabled(false);
                    setResponseMessage(t("There was an error occurred, Please try again later."));   
                }
            }

            const result = await response.json();
            const WorkitemId = result.WorkitemId;

            if (response.ok) {
                setIsLoading(false)
                if (attahcments) {
                    sendAttachments(WorkitemId)
                }
                notifyChatbot();
            } else {
                // Handle error response from the server
                setIsFormDisabled(false)
                setIsLoading(false)
            }
        } catch (error) {
            setIsFormDisabled(false)
            setIsLoading(false)
            setResponseMessage(t("There was an error occurred, Please try again later."));   
            console.error('Error saving the request:', error);
        }
    };

    const notifyChatbot = () => {
        let frontendLog = {"sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language')}
        const requestData = {
            message: t("leave returned request submitted successfully, you need any help?"),
            user_lang: language,
            frontendLog: frontendLog
        };
  
        fetch(`${process.env.REACT_APP_BACKEND_URL}/chatbot/rephraseMessage?code=${process.env.REACT_APP_CHATBOT_FUNCTION_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                onSendMessage({ sender: 'bot', text: data.message, clearHistory: data.clearHistory });
                setTimeout(() => {
                    onSendMessage({
                        sender: 'bot',
                        isRating: true,
                        requestType: data.requestType,
                        timestamp: new Date().getTime(),
                    });
                }, (process.env.REACT_APP_TIME_TO_DISPLAY_REVIEW * 1000));
                sessionStorage.setItem('clearHistory', true)
                //   setIsLoading(false);
            })
            .catch(error => {
                console.error('Error making API request:', error);
            });
    };

    const handleRowClick = (leave) => {
        if (!isDisabled) {
            setSelectedLeave(leave);
            setReturnDate(formatDateWithDashes(formatDate(leave.Retdt))); // Pre-fill the return date if present
            if (leave.Ismat) {
                setIsWorkScheduleRequired(true);
                fetchWorkSchedules();
            } else {
                setIsWorkScheduleRequired(false);
            }
        }
    };

    const handleCancel = () => {
        setSelectedLeave(null);
        setReturnDate('');
        setNote('');
        setAttachments([]);
        setSelectedWorkSchedule('');
        setIsWorkScheduleRequired(false);
        setResponseMessage("")
        setIsErrorMessage(false)
        setValidationMessage("")
    };

    const fetchWorkSchedules = async () => {
        try {
            let frontendLog = JSON.stringify({"sessionID": sessionStorage.getItem('sessionID'), "EmployeeID": localStorage.getItem('EmployeeID'), "channel": isMobile ? "Mobile" : "Portal", "language": localStorage.getItem('language')})
            const params = new URLSearchParams({
                token: localStorage.getItem('id_token'),
                sessionID: sessionStorage.getItem('sessionID'),
                frontendLog: frontendLog,
                language: localStorage.getItem('language')
            });
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/getWorkScheduleList?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&${params}`);
            const data = await response.json();
            setWorkSchedules(data);
        } catch (error) {
            console.error('Error fetching work schedule:', error);
        }
    };
    const sendAttachments = async (WorkitemId) => {
        let frontendLog = JSON.stringify({
          "sessionID": sessionStorage.getItem('sessionID'),
          "EmployeeID": localStorage.getItem('EmployeeID'),
          "channel": isMobile ? "Mobile" : "Portal",
          "language": localStorage.getItem('language')
        });

        const uploadParams = new URLSearchParams({
          "token": localStorage.getItem('id_token'),
          EmployeeID: localStorage.getItem('EmployeeID'),
          "x-csrf-token": csrfToken,
          "cookies": cookies,
          "sessionID": sessionStorage.getItem('sessionID'),
          "frontendLog": frontendLog
        }).toString();

        let fileOrder = 1; // Start the file order from 1

        // Iterate over each file and send the binary data directly
        for (const file of attahcments) {
          const arrayBuffer = await file.arrayBuffer(); // Convert file to binary ArrayBuffer
          
          // Encode the file name for spaces and construct the slug
          const encodedFileName = encodeURIComponent(file.name);
          const fileType = file.type.split('/')[1]; // Extract the file type (e.g., 'png', 'jpg')
          const leaveWorkitemId = WorkitemId; // Placeholder value for LeaveWorkitemId
          const slug = `${encodedFileName}|${fileType}|B|${leaveWorkitemId}|${fileOrder}`;
      
          const uploadResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/middleware/sendReturnFromLeaveAttachments?code=${process.env.REACT_APP_MIDDLEWARE_FUNCTION_KEY}&${uploadParams}`, {
            method: 'POST',
            headers: {
              'Content-Type': file.type, // Set appropriate content type (e.g., image/jpeg, application/pdf)
              'Slug': slug, // Use the custom slug format here
            },
            body: arrayBuffer, // Send binary data as the request body
          });
      
          if (!uploadResponse.ok) {
            throw new Error('Error uploading attachment: ' + uploadResponse.statusText);
          }
      
          const uploadData = await uploadResponse.json();
      
          fileOrder++; // Increment the file order for the next file
        }
      };      

    const handleFilePondUpdate = (fileItems) => {
        const files = fileItems.map(fileItem => fileItem.file);

        // Check if all files are of accepted types
        const allValid = files.every(file => attachmentFilesTypes.includes(file.type));
        setValidFiles(allValid);
        if (!allValid) {
            setValidationMessage(t("One or more files are not in the correct format."))
            setAttachments(fileItems.map(fileItem => fileItem.file));
        } else {
            setValidationMessage("")
            setAttachments(fileItems.map(fileItem => fileItem.file));
        }
    };

    function formatDateWithDashes(dateString) {
        // Split the input string by the dot (.)
        const [day, month, year] = dateString.split('.');

        // Format the output as YYYY-MM-DD
        return `${year}-${month}-${day}`;
    }

    function formatDateForPreview(dateString) {
        // Split the input string by the dot (.)
        const [day, month, year] = dateString.split('.');

        // Format the output as MM/DD/YYYY
        return `${month}/${day}/${year}`;
    }
    function calculateTwoYearsLater(startDate) {
        const [month, day, year] = startDate.split('/');
        const start = new Date(`${year}-${month}-${day}`); // Convert to date format
        start.setFullYear(start.getFullYear() + 2); // Add two years

        // Adjust the date for leap years
        const adjustedDate = new Date(start);
        adjustedDate.setDate(start.getDate() - 1); // Subtract 1 day

        // Format the adjusted date back to MM/DD/YYYY
        const formattedMonth = String(adjustedDate.getMonth() + 1).padStart(2, '0');
        const formattedDay = String(adjustedDate.getDate()).padStart(2, '0');
        const formattedYear = adjustedDate.getFullYear();

        return `${formattedMonth}/${formattedDay}/${formattedYear}`;
    }

    return (
        <div className={`leave-container w-100 ${isDisabled ? 'disabled-class' : ''}`}>
            {selectedLeave ? (
                <div className="form-card">
                    <div className="form-card-title">
                        {t('When will you be on vacation?')}
                    </div>
                    <form>
                        {isLoading &&
                            <div className='centered-v-h loading-overlay'>
                                <img className="img-bottom" src={loadingGif} alt="Loading..." width={70} height={70} />
                                <span className="span-bottom">{t('Processing, please wait ...')}</span>
                            </div>
                        }
                        <div className='mb-3'>
                            <label>{t('Employee QID')}</label>
                            <input type="text" value={selectedLeave.Qid} className='form-control' readOnly disabled />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Employee Number')}</label>
                            <input type="text" value={selectedLeave.Pernr} className='form-control' readOnly disabled />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Employee Name')}</label>
                            <input type="text" value={selectedLeave.Ename} className='form-control' readOnly disabled />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Leave Type')}</label>
                            <input type="text" value={selectedLeave.Ltxt} className='form-control' readOnly disabled />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Request Type')}</label>
                            <input type="text" value={selectedLeave.Rtxt} className='form-control' readOnly disabled />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Expected return from leave date')}</label>
                            <input type="text" className='form-control' value={formatDateForPreview(formatDate(selectedLeave.Expdt))} readOnly disabled />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Return date')}</label>
                            <DateInput
                                value={returnDate}
                                onChange={(e) => setReturnDate(e.target.value)}
                                className={validationMessage ? 'is-invalid' : ''}
                                disabled={isDisabled}
                                placeholder={t('Select return date')}
                            />
                        </div>

                        {/* Conditionally render work schedule field */}
                        {isWorkScheduleRequired && (
                            <fieldset className="group-box mb-3">
                                <legend className="group-box-title">{t('Maternity Workschedule')}</legend>
                                <div className='mb-3'>
                                    <div className="d-flex align-items-center">
                                        <select
                                            className={`form-control me-2 ${validationMessage && !selectedWorkSchedule ? 'is-invalid' : ''}`}
                                            value={selectedWorkSchedule}
                                            onChange={(e) => setSelectedWorkSchedule(e.target.value)}
                                            required={isWorkScheduleRequired}
                                            disabled={isDisabled}
                                        >
                                            <option value="">{t('Select Work Schedule')}</option>
                                            {workSchedules.map((schedule, index) => (
                                                <option key={index} value={schedule.Schkz}>
                                                    {schedule.Schkz} - {schedule.Rtext}
                                                </option>
                                            ))}
                                        </select>
                                        <div className='mb-3'>
                                            <label>{t('Start Date')}</label>
                                            <input type="text" className='form-control' value={formatDateForPreview(formatDate(selectedLeave.Expdt))} readOnly disabled />
                                        </div>
                                        <div className='mb-3'>
                                            <label>{t('End Date')}</label>
                                            <input type="text" className='form-control' value={calculateTwoYearsLater(formatDateForPreview(formatDate(selectedLeave.Expdt)))} readOnly disabled />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        )}


                        <div className='mb-3'>
                            <label>{t('Notes')}</label>
                            <textarea
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                className='form-control'
                                disabled={isDisabled}
                            />
                        </div>
                        <div className='mb-3'>
                            <label>{t('Attachments')}</label>
                            <FilePond
                                files={attahcments}
                                allowMultiple={true}
                                onupdatefiles={handleFilePondUpdate}
                                acceptedFileTypes={['image/jpeg', 'image/tiff', 'image/gif', 'application/pdf']}
                                labelIdle={"<span class='large-font'> + </span>" + t('Drag & Drop your files or') + ' <span class="filepond--label-action"> ' + t('Browse') + ' </span>'}
                                disabled={isDisabled}
                            />
                        </div>
                        {validationMessage && !selectedWorkSchedule && (
                            <div className="red-span">{validationMessage}</div>
                        )}
                        {responseMessage && <span className={isErrorMessage ? 'red-span' : 'green-span'}>{responseMessage}</span>}
                        <div className="form-buttons mb-3">
                            <button type="button" disabled={isDisabled} className="submit-button" onClick={handleSave}>{t('Save')}</button>
                            <button type="button" disabled={isDisabled} className="cancel-button" onClick={handleCancel}>{t('Cancel')}</button>
                        </div>
                    </form>
                </div>
            ) : (
                <div className="update-leave-container w-100">
                    {data?.data && data?.data?.length > 0 ? (
                        <>
                            <ul className='update-leave-list'>
                                {data?.data?.map((leave, index) => (
                                    <li className='update-leave-list-item' key={index} onClick={() => handleRowClick(leave)}>
                                        <div className='update-leave-list-item-header'>
                                            <div className='update-leave-list-item-header-title'>{leave.Ltxt}</div>
                                            <div className='update-leave-list-item-header-actions'>
                                                <FontAwesomeIcon className='arrow-right' icon={language == "ar" ? faChevronLeft : faChevronRight}></FontAwesomeIcon>
                                            </div>
                                        </div>
                                        <div className='update-leave-list-item-body'>
                                            <div className='update-leave-list-item-body-container'>
                                                <div className='update-leave-list-item-body-label'>{t('Start Date')}</div>
                                                <div className='update-leave-list-item-body-value'>{formatDate(leave.Begda9201)}</div>
                                            </div>
                                            <div className='update-leave-list-item-body-container'>
                                                <div className='update-leave-list-item-body-label'>{t('End Date')}</div>
                                                <div className='update-leave-list-item-body-value'>{formatDate(leave.Endda9201)}</div>
                                            </div>
                                            <div className='update-leave-list-item-body-container'>
                                                <div className='update-leave-list-item-body-label'>{t('Expected return date')}</div>
                                                <div className='update-leave-list-item-body-value'>
                                                    {formatDate(leave.Expdt)}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}

                            </ul>
                        </>
                    ) : (
                        <p>{t("You don't have leaves to return from!")}</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ReturnFromLeave;
